import { useSpring, animated, useTransition } from '@react-spring/web'
import { useEffect, useState, useRef } from 'react'
import styled, { useTheme } from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Source, ChartTitle, ChartDescription, Notes, Label } from '../styles'
import SVG from 'react-inlinesvg'
import svgSourceVd from '../../images/results-desktop-vd.svg'
import svgSourceMobileVd from '../../images/results-mobile-vd.svg'
import svgSourceGe from '../../images/results-desktop-ge.svg'
import svgSourceMobileGe from '../../images/results-mobile-ge.svg'
import svgArrow from '../../images/arrow.svg'

function mapRange(
  value: number,
  fromRange: [number, number],
  toRange: [number, number]
) {
  const [fromLow, fromHigh] = fromRange
  const [toLow, toHigh] = toRange

  const fraction = (value - fromLow) / (fromHigh - fromLow)

  return toLow + fraction * (toHigh - toLow)
}

const Row = ({
  year,
  value,
  start,
  tension,
}: {
  year: number
  value: number
  start: boolean
  tension: number
}) => {
  const [showSeat, setShowSeat] = useState(false)

  const spring = useSpring({
    value: start ? 1 : 0,
    config: {
      mass: 0.1,
      tension: 50 * tension,
    },
    onRest: () => {
      setShowSeat(true)
    },
  })

  const transitions = useTransition(showSeat, {
    from: { opacity: 0, scale: 0 },
    enter: { opacity: 1, scale: 1 },
    leave: { opacity: 0, scale: 0 },
  })

  console.log(value, tension)

  const rad = 50
  const trails = new Array(5)
    .fill(null)
    .map((_, i) => ({ key: i, rd: 1 + Math.random() }))

  return (
    <RowContainer>
      <Left>
        <Label>{year}</Label>
        <BarHolder>
          <BarContainer style={{ width: `${(1 - tension) * 100}%` }}>
            <BarContent
              style={{ width: spring.value.to((v) => `${v * 100}%`) }}
            >
              <Bar />
              <Value>
                {spring.value.to((v) =>
                  (v * value).toLocaleString('fr-CH', {
                    maximumFractionDigits: 0,
                  })
                )}
              </Value>
            </BarContent>
          </BarContainer>
        </BarHolder>
      </Left>
      {/* <Right>
        {transitions(
          (style, item) =>
            item && (
              <CircleContainer>
                {trails.map((trail, index) => {
                  const angle = (index / trails.length) * Math.PI * 2
                  return (
                    <Trail
                      style={{
                        scale: style.opacity.to(
                          (v) => Math.sin(v * Math.PI) * trail.rd * 0.3
                        ),
                        opacity: style.opacity.to((v) => Math.cos(v)),
                        translateX: style.opacity.to(
                          (v) => Math.cos(angle) * v * rad * trail.rd
                        ),
                        translateY: style.opacity.to(
                          (v) => Math.sin(angle) * v * rad * trail.rd
                        ),
                      }}
                    />
                  )
                })}
                <HandleContainer style={style} />
              </CircleContainer>
            )
        )}
      </Right> */}
    </RowContainer>
  )
}

const Value = styled(animated.div)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(calc(100% + 10px), -50%);
  font-size: 0.65em;
  font-weight: bold;
  color: rgb(${({ theme }) => theme.colorMain});
`

// const Label = styled.div`
//   margin-right: 30px;
//   font-size: 0.85em;
//   line-height: 1;
//   display: block;
// `

const BarContent = styled(animated.div)`
  position: relative;
  height: 100%;
`

const Left = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`
const Right = styled.div``

const RowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(${({ theme }) => theme.grayColorMedium});

  &:last-child {
    border: 0;
  }
`

const BarHolder = styled.div`
  background-color: rgb(${({ theme }) => theme.grayColorLight});
  width: 100%;
  height: 30px;
`

const BarContainer = styled.div`
  height: 100%;
`

const Trail = styled(animated.div)`
  width: 10px;
  height: 10px;
  background-color: rgba(${({ theme }) => theme.colorMain});
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -5px;
  margin-left: -5px;
  border-radius: 50%;
  z-index: 0;
`

const CircleContainer = styled.div`
  position: relative;
  padding: 2px;
`

const HandleContainer = styled(animated.div)`
  width: 26px;
  height: 26px;
  background-color: rgba(${({ theme }) => theme.colorMain});
  border: 2px solid rgba(${({ theme }) => theme.colorMainDark});
  border-radius: 50%;
  cursor: grab;
  user-select: none;
  position: relative;
  z-index: 1;

  &:last-child {
    margin-right: 0;
  }
`

const Bar = styled.div`
  height: 100%;
  background-color: rgb(${({ theme }) => theme.colorMain});
  width: 100%;
`

const MinList = ({ data }: { data: Map<number, number> }) => {
  const observer = useRef<IntersectionObserver | null>(null)
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null)
  const [start, setStart] = useState(false)
  const values = [...data.values()]
  // const [min, max] = [Math.min(...values), Math.max(...values)]
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const theme = useTheme()

  const handleIntersection = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        console.log('intersecting')
        setStart(true)
      }
    })
  }

  useEffect(() => {
    if (!containerRef) return

    console.log(containerRef)

    let options = {
      rootMargin: '0px',
      threshold: 0.75,
    }

    observer.current = new IntersectionObserver(handleIntersection, options)
    observer.current.observe(containerRef as Element)
  }, [containerRef])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const labelsData: {
    [key: string]: {
      total: number[]
      values: number[][]
      positions: { date: number[][]; number: number[][] }
    }
  } = {
    '24heures': {
      total: [187644, 183970, 171084, 183426, 159654],
      values: [
        isMobile ? [181, 11, 3] : [181, 17, 5],
        isMobile ? [2991, 10, 70] : [2991, 17, 43],
        isMobile ? [624, 42, 32] : [624, 15, 68],
        isMobile ? [1622, 43, 70] : [1622, 15, 90],
        isMobile ? [2553, 77, 32] : [2553, 68, 15],
      ],
      positions: {
        date: [
          isMobile ? [1, 12] : [7, 3],
          isMobile ? [1, 52] : [7, 28],
          isMobile ? [36, 12] : [7, 53],
          isMobile ? [36, 52] : [7, 78],
          isMobile ? [70, 12] : [58, 3],
        ],
        number: [
          isMobile ? [31, 12] : [50.5, 3],
          isMobile ? [31, 52] : [50.5, 27.5],
          isMobile ? [63, 12] : [47.5, 53],
          isMobile ? [66, 52] : [50.5, 78],
          isMobile ? [95, 12] : [94, 3],
        ],
      },
    },
    tdg: {
      total: [102496, 106852, 101795, 110376, 101081],
      values: [
        isMobile ? [523, 14, 3] : [523, 20, 8],
        isMobile ? [2087, 10, 72] : [2087, 19, 42],
        isMobile ? [69, 41, 38] : [69, 15, 68],
        isMobile ? [1884, 42, 73] : [1884, 18, 87],
        isMobile ? [758, 73, 35] : [758, 62, 19],
      ],
      positions: {
        date: [
          isMobile ? [4, 12] : [9, 7],
          isMobile ? [4, 56] : [9, 30],
          isMobile ? [36, 12] : [9, 53],
          isMobile ? [36, 56] : [9, 76],
          isMobile ? [68, 12] : [56, 7],
        ],
        number: [
          isMobile ? [28, 12] : [46, 7],
          isMobile ? [28, 55.5] : [46, 30],
          isMobile ? [59, 12] : [46, 53],
          isMobile ? [60, 55.5] : [46, 76],
          isMobile ? [90.5, 12] : [92, 7],
        ],
      },
    },
  }

  const labels = labelsData[theme.tenant] || labelsData['tdg']

  return (
    <Container ref={setContainerRef}>
      <TextWidth>
        <ChartTitle>
          Quelques centaines de voix peuvent faire une différence
        </ChartTitle>
        <ChartDescription>
          Nombre de voix minimum pour changer le résultat d'une élection
          fédérale au Conseil national dans le canton de{' '}
          {theme.tenant === '24heures' ? 'Vaud' : 'Genève'}. Seuls les
          principaux apparentements sont pris en compte.
        </ChartDescription>
        {/* <DropdownContainer>
          <Dropdown
            handleChange={(value) => {
              console.log(value)
            }}
            placeholder='Vaud'
            items={[
              { label: 'Vaud', value: 'vd' },
              { label: 'Genève', value: 'ge' },
            ]}
          />
        </DropdownContainer> */}
      </TextWidth>
      <Content>
        <Label
          style={{
            top: `${labels.positions.date[0][0]}%`,
            left: `${labels.positions.date[0][1]}%`,
          }}
        >
          2019
        </Label>

        {labels.positions.number.map((l, i) => (
          <LegendLabel
            style={{
              top: `${labels.positions.number[i][0]}%`,
              left: `${labels.positions.number[i][1]}%`,
              width: isMobile ? '32%' : '16%'
            }}
          >
            <div>
              <b>{labels.total[i].toLocaleString('fr-CH')}</b> votants
            </div>
            <div style={{whiteSpace: 'nowrap'}}>
              <LegendUnit /> = 100 votants
            </div>
          </LegendLabel>
        ))}

        <Label
          style={{
            top: `${labels.positions.date[1][0]}%`,
            left: `${labels.positions.date[1][1]}%`,
          }}
        >
          2015
        </Label>

        <Label
          style={{
            top: `${labels.positions.date[2][0]}%`,
            left: `${labels.positions.date[2][1]}%`,
          }}
        >
          2011
        </Label>

        <Label
          style={{
            top: `${labels.positions.date[3][0]}%`,
            left: `${labels.positions.date[3][1]}%`,
          }}
        >
          2007
        </Label>

        <Label
          style={{
            top: `${labels.positions.date[4][0]}%`,
            left: `${labels.positions.date[4][1]}%`,
          }}
        >
          2003
        </Label>

        <StyledSvg
          src={
            isMobile
              ? theme.tenant === '24heures'
                ? svgSourceMobileVd
                : svgSourceMobileGe
              : theme.tenant === '24heures'
              ? svgSourceVd
              : svgSourceGe
          }
          width={'100%'}
          height='auto'
          title='React'
        />

        <Label
          style={{ fontSize: '0.75em', top: `${labels.values[0][1]}%`, left: `${labels.values[0][2]}%`, textAlign: 'right', width: 150 }}
        >
          <StyledArrow
            style={{
              position: 'absolute',
              left: '75%',
              top: '-30px',
              transform: 'scaleX(1) rotate(-50deg)',
            }}
            src={svgArrow}
            width={'40px'}
          />
          <b>{labels.values[0][0].toLocaleString('fr-CH')}</b> personnes
          auraient suffit pour faire basculer un siège d'une alliance à une autre
        </Label>

        {labels.values.slice(1).map((l) => (
          <Label
            style={{ top: `${l[1]}%`, left: `${l[2]}%`, textAlign: 'left' }}
          >
            <b>{l[0].toLocaleString('fr-CH')}</b>
          </Label>
        ))}

        {/* {[...data].map(([year, value]) => {
          return (
            <Row
              tension={mapRange(value, [min, max], [0.9, 0.4])}
              year={year}
              start={start}
              value={value}
            />
          )
        })} */}
      </Content>
      <TextWidth>
        <Notes>
          En ne tenant compte que des apparentements principaux et des votes par liste.
        </Notes>
        <Source>Source: Tamedia, Chancellerie fédérale</Source>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div`
  // background-color: rgb(${({ theme }) => theme.grayColorLight});
  margin: 0 auto;
  margin-bottom: 90px;
`

const LegendLabel = styled(Label)`
  font-size: 0.5em;
  display: flex;
  justify-content: space-between;
`

const Content = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
`

const LegendUnit = styled.div`
  width: 6px;
  height: 6px;
  background: ${({ theme }) => `rgb(${theme.grayColorMedium})`};
  display: inline-block;
`

const DropdownContainer = styled.div`
  margin-bottom: 20px;
`

// @ts-ignore
const StyledArrow = styled(SVG)`
  path {
    opacity: 1;
    fill: ${({ theme }) => `rgb(${theme.colorBlueDark})`};
  }
`

// @ts-ignore
const StyledSvg = styled(SVG)`
  position: relative;

  g[id^='grey'] {
    rect,
    polygon {
      fill: ${({ theme }) => `rgb(${theme.grayColorMedium})`};
    }
  }

  g[id^='grid'] {
    line {
      stroke: ${({ theme }) => `rgb(${theme.siteBackground})`};
    }
  }

  g[id^='color'] {
    rect,
    polygon {
      fill: ${({ theme }) => `rgb(${theme.colorMain})`};
    }
  }
`

export default MinList
